import React from 'react';

interface SummaryCardProps {
  summary: {
    total: number;
    totalPnL: number;
    totalRealizedPnl: number;
    longCount: number;
    shortCount: number;
    longPnL: number; // 做多总盈亏
    longRealizedPnl: number; // 做多已实现盈亏
    shortPnL: number; // 做空总盈亏
    shortRealizedPnl: number; // 做空已实现盈亏
    type2Count: number;
    type3Count: number;
  };
}

const SummaryCard: React.FC<SummaryCardProps> = ({ summary }) => {
  const formatNumber = (num: number, decimals: number = 2) => {
    if (num === 0) return '0.00';
    return num.toFixed(decimals);
  };

  const getPnLColor = (pnl: number) => {
    if (pnl > 0) return 'text-green-300';
    if (pnl < 0) return 'text-red-300';
    return 'text-white';
  };

  return (
    <div className="mb-6">
      <div className="bg-white/5 border border-white/20 rounded-xl p-4">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-white/90 text-base font-semibold">持仓统计</h2>
          <span className="text-white/60 text-sm">总计: {summary.total}</span>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-white/5 rounded-lg p-3">
            <div className="text-white/60 text-xs mb-1">总盈亏</div>
            <div className={`text-lg font-bold ${getPnLColor(summary.totalPnL)}`}>{formatNumber(summary.totalPnL)}</div>
          </div>
          <div className="bg-white/5 rounded-lg p-3">
            <div className="text-white/60 text-xs mb-1">已实现盈亏</div>
            <div className={`text-lg font-bold ${getPnLColor(summary.totalRealizedPnl)}`}>
              {formatNumber(summary.totalRealizedPnl)}
            </div>
          </div>
          <div className="bg-white/5 rounded-lg p-3">
            <div className="text-white/60 text-xs mb-1">做多</div>
            <div className="text-white text-lg font-bold">{summary.longCount}</div>
            <div className={`text-xs mt-1 ${getPnLColor(summary.longPnL)}`}>
              总盈亏: {formatNumber(summary.longPnL)}
            </div>
            <div className={`text-xs mt-0.5 ${getPnLColor(summary.longRealizedPnl)}`}>
              已实现: {formatNumber(summary.longRealizedPnl)}
            </div>
          </div>
          <div className="bg-white/5 rounded-lg p-3">
            <div className="text-white/60 text-xs mb-1">做空</div>
            <div className="text-white text-lg font-bold">{summary.shortCount}</div>
            <div className={`text-xs mt-1 ${getPnLColor(summary.shortPnL)}`}>
              总盈亏: {formatNumber(summary.shortPnL)}
            </div>
            <div className={`text-xs mt-0.5 ${getPnLColor(summary.shortRealizedPnl)}`}>
              已实现: {formatNumber(summary.shortRealizedPnl)}
            </div>
          </div>
          <div className="bg-white/5 rounded-lg p-3">
            <div className="text-white/60 text-xs mb-1">完全平仓</div>
            <div className="text-white text-lg font-bold">{summary.type2Count}</div>
          </div>
          <div className="bg-white/5 rounded-lg p-3">
            <div className="text-white/60 text-xs mb-1">强平</div>
            <div className="text-white text-lg font-bold">{summary.type3Count}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;
